const ENABLED_VALUES = new Set(['1', 'true', 'yes', 'on']);

export const FEATURE_FLAGS = Object.freeze({
  fullPlatform: 'REACT_APP_ENABLE_FULL_PLATFORM',
  campaignVoting: 'REACT_APP_ENABLE_CAMPAIGN_VOTING',
  marketplaceListings: 'REACT_APP_ENABLE_MARKETPLACE_LISTINGS',
  marketplaceBarter: 'REACT_APP_ENABLE_MARKETPLACE_BARTER',
  marketplaceStripe: 'REACT_APP_ENABLE_MARKETPLACE_STRIPE',
  marketplaceTrades: 'REACT_APP_ENABLE_MARKETPLACE_TRADES', // Legacy umbrella; do not use for new release decisions.
  bitcoinExperience: 'REACT_APP_ENABLE_BITCOIN_EXPERIENCE', // Every visible BTC surface and all BTC-specific wording.
  bitcoinTransactions: 'REACT_APP_ENABLE_BITCOIN_TRANSACTIONS',
  sheafPurchase: 'REACT_APP_ENABLE_SHEAF_PURCHASE',
  groupStripeFinance: 'REACT_APP_ENABLE_GROUP_STRIPE_FINANCE',
  stripeCampaignFunding: 'REACT_APP_ENABLE_STRIPE_CAMPAIGN_FUNDING',
  cashCheckStewardship: 'REACT_APP_ENABLE_CASH_CHECK_STEWARDSHIP',
  services: 'REACT_APP_ENABLE_SERVICES',
  jobsPayroll: 'REACT_APP_ENABLE_JOBS_PAYROLL',
  testDataTools: 'REACT_APP_ENABLE_TEST_DATA_TOOLS',
});

const BUILD_TIME_ENV = Object.freeze({
  [FEATURE_FLAGS.fullPlatform]: process.env.REACT_APP_ENABLE_FULL_PLATFORM,
  [FEATURE_FLAGS.campaignVoting]: process.env.REACT_APP_ENABLE_CAMPAIGN_VOTING,
  [FEATURE_FLAGS.marketplaceTrades]: process.env.REACT_APP_ENABLE_MARKETPLACE_TRADES,
  [FEATURE_FLAGS.marketplaceListings]: process.env.REACT_APP_ENABLE_MARKETPLACE_LISTINGS,
  [FEATURE_FLAGS.marketplaceBarter]: process.env.REACT_APP_ENABLE_MARKETPLACE_BARTER,
  [FEATURE_FLAGS.marketplaceStripe]: process.env.REACT_APP_ENABLE_MARKETPLACE_STRIPE,
  [FEATURE_FLAGS.bitcoinExperience]: process.env.REACT_APP_ENABLE_BITCOIN_EXPERIENCE,
  [FEATURE_FLAGS.bitcoinTransactions]: process.env.REACT_APP_ENABLE_BITCOIN_TRANSACTIONS,
  [FEATURE_FLAGS.sheafPurchase]: process.env.REACT_APP_ENABLE_SHEAF_PURCHASE,
  [FEATURE_FLAGS.groupStripeFinance]: process.env.REACT_APP_ENABLE_GROUP_STRIPE_FINANCE,
  [FEATURE_FLAGS.stripeCampaignFunding]: process.env.REACT_APP_ENABLE_STRIPE_CAMPAIGN_FUNDING,
  [FEATURE_FLAGS.cashCheckStewardship]: process.env.REACT_APP_ENABLE_CASH_CHECK_STEWARDSHIP,
  [FEATURE_FLAGS.services]: process.env.REACT_APP_ENABLE_SERVICES,
  [FEATURE_FLAGS.jobsPayroll]: process.env.REACT_APP_ENABLE_JOBS_PAYROLL,
  [FEATURE_FLAGS.testDataTools]: process.env.REACT_APP_ENABLE_TEST_DATA_TOOLS,
});

function defaultEnvironment() {
  return process.env.NODE_ENV === 'test' ? process.env : BUILD_TIME_ENV;
}

export function parseFeatureFlag(value, defaultValue = false) {
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }

  return ENABLED_VALUES.has(String(value).trim().toLowerCase());
}

export function isFeatureEnabled(flag, environment = defaultEnvironment()) {
  if (!Object.values(FEATURE_FLAGS).includes(flag)) {
    throw new Error(`Unknown feature flag: ${flag}`);
  }

  return parseFeatureFlag(environment[flag]);
}

export function readFeatureFlags(environment = defaultEnvironment()) {
  return Object.fromEntries(
    Object.entries(FEATURE_FLAGS).map(([name, variable]) => [
      name,
      isFeatureEnabled(variable, environment),
    ]),
  );
}

